import React from 'react';
import './Pricingcard.css';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { useState } from 'react';
import HomeIcon from '../../Images/HomeImages/house.png'
import BuildingImg from '../../Images/HomeImages/kitchen-hood.png'
import SecurityImg from '../../Images/HomeImages/sofa.png'
const PricingComponent = () => {
    const [cart, setCart] = useState([]);
    const [services, setServices] = useState([]);

    // const addToCart = (service) => {
    //     let cartItems = [...cart];
    //     const existingIndex = cartItems.findIndex(item => item.id === service.id);

    //     if (existingIndex > -1) {
    //         cartItems[existingIndex].qty += 1;
    //     } else {
    //         service.qty = 1;
    //         cartItems.push(service);
    //     }

    //     localStorage.setItem("cart", JSON.stringify(cartItems));
    //     message.success('Item Added in Cart');
    //     setCart(cartItems);
    // };
    return (
        <div className="pricing-container">
            <div className="pricing-card">
                <div className="img-container-pricing-card">
                    <div className="img-container-pricing-card-innercircle" style={{ backgroundColor: "#ffdd66" }}>
                        <img src={HomeIcon} alt="" />
                    </div>
                </div>
                <div className="card-header">
                    <h3>Intense bathroom Cleaning</h3>
                    <h1>₹349</h1>
                    {/* <p>/ Per Month</p> */}
                </div>
                <ul className="card-features">
                    <li>Geyser Exhaust Window</li>
                    <li>Stain romovel Tiles</li>
                    <li>Glass partition & mirrors</li>
                    <li>Basin Toilet Water closet</li>
                </ul>
                <Link to='/bathroom-cleaning'><button className="buy-button" >View More</button></Link>
            </div>

            <div className="pricing-card yellow-card">
                <div className="img-container-pricing-card">
                    <div className="img-container-pricing-card-innercircle" style={{ backgroundColor: "#2A4765" }}>
                        <img src={BuildingImg} alt="" />
                    </div>
                </div>
                <div className="card-header">
                    <h3>Kitchen Cleaning</h3>
                    <h1> ₹1199
                    </h1>
                    {/* <p>/ Per Month</p> */}
                </div>
                <ul className="card-features">
                    <li>Tiles and Stove .</li>
                    <li>Countertops.</li>
                    <li>Chimney Exteriors & Filters.</li>
                    <li>Sink and Faucet.</li>
                </ul>
                <Link to='/Kitchen-cleaning'><button className="buy-button" style={{ backgroundColor: '#2A4765' }} >View More</button></Link>
            </div>

            <div className="pricing-card">
                <div className="img-container-pricing-card">
                    <div className="img-container-pricing-card-innercircle" style={{ backgroundColor: "#ffdd66" }}>
                        <img src={SecurityImg} alt="" />
                    </div>
                </div>
                <div className="card-header">
                    <h3>Sofa Shampooing Cleaning</h3>
                    <div>
                        <h1> ₹449</h1>
                        <p>( For 3 Seater )</p>
                    </div>
                </div>
                <ul className="card-features">
                    <li>Dry vacuum.</li>
                    <li>Shampooing
                        .</li>
                    <li>Wet vacuum
                        .</li>
                    <li>Drying.</li>
                </ul>
                <button className="buy-button">View More</button>
            </div>
        </div>
    );
};

export default PricingComponent;
